export const SCORE_TIERS = {
	good: { min: 0.8, class: 'bg-green-50 text-success' },
	warn: { min: 0.6, class: 'bg-yellow-50 text-warning' },
	bad: { min: 0, class: 'bg-red-50 text-error' },
} as const;

export const SIZE_CLASS = {
	sm: 'px-xs py-3xs text-[11px]',
	md: 'px-sm py-2xs text-[13px]',
	lg: 'px-md py-xs text-[18px] font-semibold',
} as const;
